import styled from 'styled-components'

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
`

export const TextWrapper = styled.div`
  > p {
    margin-bottom: 12px;
    line-height: 16px;
  }
`

export const ButtonWrapper = styled.div`
  margin-top: 20px;
`
